import React from 'react'
import Container from 'js/pages/LandingPages/components/Container'
import Stars from 'js/pages/LandingPages/components/Stars'
import { appleRating, googleRating, reviewCount } from 'lifesum-shared/reviews'
import useLocale from 'js/hooks/useLocale'
import Android from '../assets/android.svg?svgr-webpack'
import Apple from '../assets/apple.svg?svgr-webpack'

type Props = {
  title: string
  reviews: { text: string | null }[]
}

const ReviewsBlock = ({ title, reviews }: Props) => {
  const { language } = useLocale()

  return (
    <section>
      <Container>
        <h2 className="quincy max-w-[620px] pb-32 text-left text-32 leading-37 lg:pb-24 lg:text-48 lg:leading-52">
          {title}
        </h2>
        <div className="grid gap-y-[16px] pb-24 lg:grid-cols-3 lg:gap-x-[40px] lg:gap-y-0">
          {reviews.map(({ text }, index) => (
            <div
              key={index}
              className="rounded-8 bg-BgContent p-16 shadow-greyShadow"
            >
              <Stars />
              <p className="pt-12 text-14 font-semiregular leading-19 text-black">
                {text}
              </p>
            </div>
          ))}
        </div>
        <div className="flex gap-x-[24px] pb-8">
          <div className="flex items-center">
            <Apple width="24" />
            <p className="mx-8 mt-4 inline-block text-17 font-demibold leading-23 tracking-1.36">
              {appleRating}
            </p>
            <Stars />
          </div>
          <div className="flex items-center">
            <Android width="24" />
            <p className="mx-8 mt-4 inline-block text-17 font-demibold leading-23 tracking-1.36">
              {googleRating}
            </p>
            <Stars />
          </div>
        </div>
        <p className="text-14 font-semiregular leading-19 ">
          Based on {new Intl.NumberFormat(language).format(reviewCount)} reviews
        </p>
      </Container>
    </section>
  )
}

export default ReviewsBlock
